import * as React from 'react';
import { AndroidView, IOSView } from 'react-device-detect';
import clsx from 'clsx';
import { WithTranslation, withTranslation } from 'react-i18next';
import i18next from 'i18next';
import { switchLanguage } from 'utils/lang';
import {
    PanelHeader,
    CloseButton,
    PanelBody,
    Icons,
    AnchorLinkButton,
    LinkButton,
    Button,
    Pictures
} from 'components';
import { SlideUpPanel } from '../slideup-panel';

import './style.scss';

export interface IMobileUIUserMenuProps extends WithTranslation {
    open: boolean;
    onClose: () => void;
    onLoginClick: () => void;
    onLogoutClick: () => void;
    onFavClick: () => void;
    onApplianceClick: () => void;
}
export interface IMobileUIUserMenuState {}

class MobileUIUserMenuComponent extends React.Component<IMobileUIUserMenuProps, IMobileUIUserMenuState> {
    constructor(props: IMobileUIUserMenuProps) {
        super(props);
    }

    render() {
        let { t } = this.props;
        return (
            <SlideUpPanel
                fullscreen
                open={this.props.open}
                className='mobile-ui-user-menu'
            >
                <PanelHeader>
                    <div
                        className="coat-wrapper"
                        onClick={() => {
                            window.location.reload();
                        }}
                    >
                        <Icons.IconCoa3 />
                    </div>
                    <div className="header-text">
                        {t('Инвестиционное развитие территории Ленинградской области')}
                    </div>
                    <CloseButton onClick={this.props.onClose} />
                </PanelHeader>
                <PanelBody>
                    <div className="user-menu-items">
                        <div className="menu-item with-padding" onClick={this.props.onFavClick}>
                            <LinkButton
                                icon={<Icons.IconStar height={38} />}
                                label={t('Избранное')}
                                className='user-menu-link-button'
                            />
                        </div>

                        {/* <div className="menu-item with-padding"> */}
                        {/*    <LinkButton */}
                        {/*        icon={<Icons.IconColoredRuFlag height={38} />} */}
                        {/*        label={t('Русский')} */}
                        {/*        className={clsx('user-menu-link-button', 'language-button', { */}
                        {/*            'current-language': i18next.language === 'ru' */}
                        {/*        })} */}
                        {/*        onClick={(e) => { */}
                        {/*            if (i18next.language === 'ru') { */}
                        {/*                e.preventDefault(); */}
                        {/*                return; */}
                        {/*            } */}
                        {/*            switchLanguage('ru'); */}
                        {/*        }} */}
                        {/*    /> */}
                        {/* </div> */}

                        {/* <div className="menu-item with-padding"> */}
                        {/*    <LinkButton */}
                        {/*        icon={<Icons.IconColoredEnFlag height={38} />} */}
                        {/*        label={t('English')} */}
                        {/*        className={clsx('user-menu-link-button', 'language-button', { */}
                        {/*            'current-language': i18next.language === 'en' */}
                        {/*        })} */}
                        {/*        onClick={(e) => { */}
                        {/*            if (i18next.language === 'en') { */}
                        {/*                e.preventDefault(); */}
                        {/*                return; */}
                        {/*            } */}
                        {/*            switchLanguage('en'); */}
                        {/*        }} */}
                        {/*    /> */}
                        {/* </div> */}

                        <div className="menu-item with-padding appliance">
                            <Button
                                text={t('Получить консультацию')}
                                onClick={this.props.onApplianceClick}
                            />
                        </div>

                        <div className="menu-splitter"></div>

                        <a href='https://lenoblinvest.ru/' className="menu-item with-padding logo">
                            <div className="logo-wrapper">
                                <Icons.BlackAndWhiteLogo />
                            </div>

                            <div className="text-wrapper">
                                {t('Инвестиционный портал Ленинградской области')}
                            </div>
                        </a>

                        {/* <div className="menu-divider"></div> */}

                        {/* { */}
                        {/*    !__IS_CORDOVA__ && ( */}
                        {/*        <div className="menu-item with-padding app-info"> */}
                        {/*            <div className="download-app-offer"> */}
                        {/*                <AndroidView> */}
                        {/*                    <Button */}
                        {/*                        className='user-menu-download-app-button' */}
                        {/*                        text={t('Скачать приложение')} */}
                        {/*                        onClick={() => { */}
                        {/*                            window.open(__ANDROID_PLAYSTORE_URL__); */}
                        {/*                        }} */}
                        {/*                    /> */}
                        {/*                </AndroidView> */}

                        {/*                <IOSView> */}
                        {/*                    <Button */}
                        {/*                        className='user-menu-download-app-button' */}
                        {/*                        text={t('Скачать приложение')} */}
                        {/*                        onClick={() => { */}
                        {/*                            window.open(__IOS_APPSTORE_URL__); */}
                        {/*                        }} */}
                        {/*                    /> */}
                        {/*                </IOSView> */}
                        {/*            </div> */}
                        {/*        </div> */}
                        {/*    ) */}
                        {/* } */}
                    </div>
                </PanelBody>
            </SlideUpPanel>
        );
    }
}

export const MobileUIUserMenu = withTranslation()(MobileUIUserMenuComponent);
